import React, { useState } from 'react'
import Timeline from './timeline-table'
import { exportTimeline } from './export'
import Icon from '@material-ui/core/Icon'

import '../../../../../css/timeline.sass'

const TimelinePage = (props) => {
  const [ascendingOrder, updateAscendingOrder] = useState(true)
  const account = props.account

  const toggleOrder = () => {
    updateAscendingOrder(!ascendingOrder)
  }

  return (
    <div className='inspect-page-container'>
      <p style={{ marginBottom: '25px', textAlign: 'center'}}><span style={{ fontWeight: 'bold'}}>{account.user.full_name} ({account.user.email_address})</span></p>
      <div className='table-head-wrapper'>
        <h2>Timeline Table</h2>
        <button className='toggle-table' onClick={toggleOrder}><Icon>swap_vert</Icon>{ascendingOrder ? 'Ascending Order' : 'Descending Order'}</button>
        <button className='toggle-table' style={{padding: '13px 16px'}} onClick={() => exportTimeline(account.timeline ? account.timeline : {}, ascendingOrder)}>Export</button>
      </div>
      <div className='timeline-container'>
        <Timeline accountId={props.accountId} account={account} ascendingOrder={ascendingOrder} macroData={props.macroData} getMacroData={props.getMacroData}/>
      </div>
    </div>
  )
}

export default TimelinePage
